import React, {useState, useEffect} from 'react'
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';  
import DeleteIcon from '@mui/icons-material/Delete';
import {useTranslation} from "react-i18next"
import {Toolbar,Typography} from '@material-ui/core';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem'; 
import ImageListItemBar from '@mui/material/ImageListItemBar';  
import "css/customDialog.css";
import PropTypes from 'prop-types';

const EnhancedTableToolbar = (props) => {
  const { numTotArticleImage, t, roles,setOpenEditNewArticleImage,setOpenEditRowArticleImage} = props; 
  const handleAddNewImages = () => {
    setOpenEditNewArticleImage(false);
    setOpenEditRowArticleImage(true);  
  };

  return (
    <Toolbar>
    <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 16}} id="tableTitle" component="div">
      {t('Text_Article_Image')} &nbsp;&nbsp;
      { roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Add_Photos')) &&
        <>
          <IconButton
            size="small"  
            style={{color:"#e74a3b", fontSize: 18}}
            onClick={handleAddNewImages}>
              <Icon
                baseClassName="fas"
                className="fa-plus add-icon-button"
              /> 
          </IconButton>&nbsp;&nbsp;
           
        </>
      }
    </Typography>
    <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
      {t('Text_Num_Image')} {(numTotArticleImage).toLocaleString('de-DE')}
    </Typography>
  </Toolbar>
);
};

  
export const TableSortingArticleImages =(props)=>{  
  const { roles,
    dataArticleImage,
    setEditRowArticleImage,
    setOpenDeleteRowArticleImage,
    setOpenEditNewArticleImage,
    setOpenEditRowArticleImage} = props;
  const {t,i18n} = useTranslation(['listDataArticles']);
  const [countData,setCountData] = useState(dataArticleImage.length);

  useEffect(
    () => {
      setCountData(dataArticleImage.length);
    },
    [dataArticleImage,countData]
  );

  const openModalDeleteRowArticleImage = (item) => {
    setEditRowArticleImage(item);
    setOpenDeleteRowArticleImage(true);
  };

  const listItemsArticleImage= (
    dataArticleImage.map((item,keyData) => {
      return (
        <ImageListItem key={keyData}>
        <img
          src={"data:"+item.type+";base64,"+item.datafile}
          alt={item.imageshield_filename}
        />
        <ImageListItemBar
          sx={{ paddingLeft:"0px",  paddingRight:"5px", background: 'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)' }}
          title={i18n.language==='es'?item.titlees.substring(1, 14):item.titleen.substring(1, 14)}
          position="top"
          actionIcon={
            <> 
            {(roles[0].listmenus.find((key)=>(key.name==='Handle_Article_Delete_Photos'))) && 
              <IconButton
                size="large"  
                style={{color:"#e74a3b", background:"white", borderRadius:10,fontSize: 10,padding:2}}
                aria-label={`star $i18n.language==='es'?item.titlees:item.titleen`}
                onClick={()=>openModalDeleteRowArticleImage(item)}
              >
                <DeleteIcon/>
              </IconButton>
            } 
            </>
            }
            actionPosition="right"
          />
        
      </ImageListItem>
      );
    }));
    

  return (
    <>
      <Box sx={{ width: '100%' }}>      
        <EnhancedTableToolbar numTotArticleImage={dataArticleImage.length} t={t} roles={roles}  setOpenEditNewArticleImage={setOpenEditNewArticleImage} setOpenEditRowArticleImage={setOpenEditRowArticleImage}/>
        <ImageList sx={{ minWidth: '100%',width: '100%' }} cols={6} rowHeight={200}>
          {listItemsArticleImage}
        </ImageList>
      </Box>
    </>
  )    
}

TableSortingArticleImages.propTypes = {
  dataArticleImage: PropTypes.array.isRequired,
  setEditRowArticleImage: PropTypes.func.isRequired,   
  setOpenDeleteRowArticleImage: PropTypes.func.isRequired,
  setOpenEditNewArticleImage: PropTypes.func.isRequired,
  setOpenEditRowArticleImage: PropTypes.func.isRequired, 
  roles: PropTypes.array.isRequired
};

export default TableSortingArticleImages;